<template>
  <div class="gs-contract-partners">
    <v-wait for="funnels">
      <div class="flex flex-col w-full bg-white rounded p-4 gs-contract-partners__card">
        <div class="w-full flex">
          <div class="flex flex-col w-full mb-6 gs-contract-partners__share-control">
            <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_groovesell_contracts_step3_share_type') }}</label>
            <gd-dropdown
              v-model="localModel.share_type"
              size="full"
              :options="shareTypeOptions"
              @change="changedShareType"
            />
          </div>
        </div>
        <div class="w-full flex gs-contract-partners__search-row">
          <div class="w-full gs-contract-partners__search-input">
            <text-input
              v-model="search"
              value="search"
              :placeholder="$t('frontend_groovesell_enter_username_or_email')"
              @keyup="changeInput"
            />
          </div>
          <gd-button
            v-if="enableButton"
            size="auto"
            variant="primary"
            class="ml-4 gs-contract-partners__add"
            @click="addPartner"
          >
            {{ $t('frontend_groovesell_contracts_step3_add_partner') }}
          </gd-button>
          <gd-button
            v-if="!enableButton"
            size="auto"
            disabled
            class="ml-4 gs-contract-partners__add"
          >
            {{ $t('frontend_groovesell_contracts_step3_add_partner') }}
          </gd-button>
        </div>

        <div
          v-if="userNotExist"
          class="w-full error text-danger mt-1 text-sm"
        >
          {{ errorMesssage }}
        </div>
        <div class="flex flex-col m-6 mb-4 gs-contract-partners__table-area">
          <div v-if="localModel.partners && localModel.partners.length > 0">
            <div
              id="second-tier-affiliates-list-view"
              class="-mx-6 flex flex-row gs-contract-partners__table-shell"
            >
              <div class="table-responsive w-full">
                <table
                  class="VueTables__table table table-striped table-bordered table-hover gs-contract-partners__table"
                >
                  <thead>
                    <tr>
                      <th scope="col" class="gs-contract-partners__partner-heading">
                        <span class="VueTables__heading">
                          {{ $t('frontend_groovesell_contracts_step3_user_name') }}
                        </span>
                        <span class="pull-right"></span>
                        <div class="resize-handle"></div>
                      </th>

                      <th scope="col" class="gs-contract-partners__allocation-heading">
                        <span v-if="localModel.share_type == 1" class="VueTables__heading">
                          {{ $t( 'frontend_groovesell_contracts_step3_partner_percentage') }}
                        </span>
                        <span v-else class="VueTables__heading">
                          {{ $t( 'frontend_groovesell_contracts_step3_partner_fixed_amount' ) }}
                        </span>
                        <span class="pull-right"></span>
                        <div class="resize-handle"></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(partner, id) in localModel.partners"
                      :key="id"
                      class="VueTables__row"
                    >
                      <td class="gs-contract-partners__partner-name">{{ partner.username }}</td>
                      <td class="gs-contract-partners__allocation">
                        <span v-if="partner.partner_id == 0">
                          {{ partner.percentage }}
                        </span>
                        <input
                          v-else
                          type="text"
                          :value="partner.percentage"
                          :aria-label="$t(localModel.share_type == 1 ? 'frontend_groovesell_contracts_step3_partner_percentage' : 'frontend_groovesell_contracts_step3_partner_fixed_amount') + ': ' + partner.username"
                          class="h-10 outline-none rounded-lg px-4 border border-grey-200 gs-contract-partners__allocation-input"
                          @keyup="calculateDistribution($event.target.value, partner)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-else class="p-4">
            {{ $t('frontend_groovesell_contracts_step3_no_partner_percentage') }}
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<style scoped>
.gs-contract-partners__card {
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-contract-partners__share-control {
  max-width: 42rem;
}

.gs-contract-partners__search-row {
  align-items: flex-start;
  gap: 12px;
}

.gs-contract-partners__search-input {
  min-width: 0;
  max-width: 42rem;
}

.gs-contract-partners__add {
  min-height: 2.75rem;
  margin-left: 0 !important;
  white-space: nowrap;
}

.gs-contract-partners__add:not(:disabled) {
  color: var(--gs-primary);
  background: var(--gs-surface);
  border: 1px solid var(--gs-primary);
  border-radius: var(--gs-radius-md);
  box-shadow: none;
}

.gs-contract-partners__add:not(:disabled):hover {
  background: var(--gs-primary-soft);
}

.gs-contract-partners__add:focus-visible,
.gs-contract-partners__allocation-input:focus-visible {
  outline: 2px solid var(--gs-primary);
  outline-offset: 2px;
}

.gs-contract-partners__table-area {
  margin: 24px 0 16px;
}

.gs-contract-partners__table-shell {
  margin: 0;
}

.gs-contract-partners__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.gs-contract-partners__table th {
  padding: 12px;
  border-bottom: 1px solid var(--gs-border);
  color: var(--gs-muted-foreground);
  background: var(--gs-surface-subtle);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-align: left;
}

.gs-contract-partners__table td {
  padding: 12px;
  border-bottom: 1px solid var(--gs-border);
  color: var(--gs-foreground);
  font-size: 14px;
  vertical-align: middle;
}

.gs-contract-partners__table tbody tr:last-child td {
  border-bottom: 0;
}

.gs-contract-partners__partner-name {
  overflow-wrap: anywhere;
}

.gs-contract-partners__allocation {
  min-width: 8rem;
}

.gs-contract-partners__allocation-input {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  width: 100%;
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border-color: var(--gs-border);
}

@media (max-width: 40rem) {
  .gs-contract-partners__card {
    padding: 16px;
  }

  .gs-contract-partners__share-control,
  .gs-contract-partners__search-input {
    max-width: none;
  }

  .gs-contract-partners__search-row {
    flex-direction: column;
  }

  .gs-contract-partners__add {
    justify-content: center;
    width: 100%;
  }

  .gs-contract-partners__table {
    table-layout: fixed;
  }

  .gs-contract-partners__partner-heading {
    width: calc(100% - 7.5rem);
  }

  .gs-contract-partners__allocation-heading,
  .gs-contract-partners__allocation {
    min-width: 0;
    width: 7.5rem;
  }

  .gs-contract-partners__table th,
  .gs-contract-partners__table td {
    padding: 12px 8px;
  }

  .gs-contract-partners__allocation-input {
    min-height: 44px;
    padding-left: 8px;
    padding-right: 8px;
    white-space: nowrap;
  }
}
</style>

<script>
import axios from 'axios';

export default {
  name: 'Step3',
  components: {
  },
  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      localModel: this.model,
      search: '',
      enableButton: false,
      userNotExist: false,
      errorMesssage: '',
    };
  },
  computed: {
    shareTypeOptions() {
      return [
        { value: 1, text: this.$t('frontend_product_step9_percentage') },
        { value: 2, text: this.$t('frontend_product_step9_fixed_amount') },
      ];
    },
  },
  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
  async created() {
    this.selectedFunnel = this.localModel.funnel_id;
    this.selectedProduct = this.localModel.product_id;
    this.selectedPricePoint = this.localModel.price_point_id;
  },
  methods: {
    changedShareType() {
      const me = this.localModel.partners.find((obj) => obj.partner_id === 0);

      if (this.localModel.share_type == 1 && me == undefined) {
          const newMe = {
            partner_id: 0,
            username: this.$t('me_vendor'),
            percentage: 0
          };

          this.localModel.partners.forEach((val) => {
            newMe.percentage += +val.percentage;
          });

          newMe.percentage = 100 - newMe.percentage;
          this.localModel.partners.unshift(newMe);
      } else {
        const deletedMeIndex = this.localModel.partners.findIndex((item) => item.id === me.id);

        if (deletedMeIndex !== -1) {
          this.localModel.partners.splice(deletedMeIndex, 1);
        }
      }
    },
    changeInput(value) {
      this.enableButton = value != '';
    },
    validate() {
      this.$emit('on-validate', true);
    },
    async addPartner() {
      this.$loader.start('addPartner');

      try {
        const userData = await axios.get('/contract/validate-user', {
          params: {
            username_or_email: this.search,
          },
        });

        if (userData.data.status !== 'success') {
          this.handleUserNotExist(userData.data.message);
          return;
        }

        const checkUser = this.localModel.partners.find((obj) => obj.partner_id === userData.data.data.id);

        if (typeof checkUser !== 'undefined') {
          this.handleUserExist();
          return;
        }

        const tempUser = {
          partner_id: userData.data.data.id,
          username: userData.data.data.name,
          percentage: 0,
        };
        this.localModel.partners.push(tempUser);
      } catch (error) {
        this.handleUserNotExist(this.$t('error_occured_user_data'));
      } finally {
        this.search = '';
        this.enableButton = false;
        this.$loader.end('addPartner');
      }
    },
    handleUserExist() {
      this.userNotExist = true;
      this.errorMesssage = this.$t('user_already_exists_contract');
      setTimeout(() => (this.userNotExist = false), 3000);
    },
    handleUserNotExist(errorMessage) {
      this.userNotExist = true;
      this.errorMesssage = errorMessage;
      setTimeout(() => (this.userNotExist = false), 3000);
    },
    async calculateDistribution(value, partner) {
      if(this.localModel.share_type == 1){
        const excludeSelf = this.calculateExcludeSelf();

        const me = this.localModel.partners.find((obj) => {
          return obj.partner_id === 0;
        });
        const remaining = 100 - excludeSelf;
    
        if (remaining - value > 0) {
          me.percentage = +me.percentage + (partner.percentage - value);
          partner.percentage = value;
        } else {
          this.handleInvalidError();
        }
      } else if(value > 0) {
           partner.percentage = value;
      } else {
        this.handleInvalidError();
        partner.percentage = 0;
      }
    },
    calculateExcludeSelf() {
      return this.localModel.partners.reduce((excludeSelf, val) => {
        return val.partner_id !== 0 ? +val.percentage + +excludeSelf : excludeSelf;
      }, 0);
    },
    handleInvalidError() {
      this.userNotExist = true;
      this.errorMesssage = this.$t('cant_set_negative_value');
      setTimeout(() => (this.userNotExist = false), 3000);
    },
  },
};
</script>
